import { createContext } from 'react';
import { featureToggles } from '~/App/config/featureToggles';

export const FeatureToggleContext = createContext<Record<string, boolean>>(
  featureToggles
);
